<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break" id="auto_bookmark_toc_1"><span>For my family, both of blood and of choice, who help me make this dream of being a writer come true. You hold me up, and I am forever grateful. Rhys, C.S., Caraway, and Hunter, thanks for always being on the other end of the screen to talk me down from my more calamitous ideas.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?8442d8ca